const features = [
  {
    icon: 'ri-refresh-line',
    title: 'Updated Weekly',
    description: 'Our CSSBuy spreadsheet directory is refreshed every week with the latest finds, ensuring you never miss a new drop or trending item.',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Quality Verified',
    description: 'Every spreadsheet undergoes manual review before being listed. We check for dead links, outdated pricing, and inaccurate product descriptions.',
  },
  {
    icon: 'ri-layout-grid-line',
    title: 'Organized Categories',
    description: 'Browse through 14 carefully organized categories — from sneakers and hoodies to accessories and fragrances — to find exactly what you need in seconds.',
  },
  {
    icon: 'ri-rocket-line',
    title: 'Fast Navigation',
    description: 'Direct links to verified product listings on our main store eliminate guesswork and get you from browsing to buying faster than ever.',
  },
  {
    icon: 'ri-scales-line',
    title: 'Comparison Guides',
    description: 'Side-by-side comparisons help you evaluate different CSSBuy spreadsheet options, pricing tiers, and agent recommendations before committing.',
  },
  {
    icon: 'ri-star-line',
    title: 'Latest Finds',
    description: 'Stay ahead of trends with early access to newly discovered gems, limited releases, and under-the-radar bargains across all categories.',
  },
];

export default function TrustSection() {
  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="text-center mb-14">
          <span className="inline-block text-xs font-semibold tracking-widest uppercase text-primary-500 mb-3">
            Why Choose Us
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-semibold text-foreground-900 mb-4">
            Trusted by Thousands of Shoppers
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
            Our CSSBuy spreadsheet directory is built on reliability, freshness, and real user feedback — here is what makes it the go-to resource for smart shoppers in 2026.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group bg-white border border-background-200/70 rounded-2xl p-6 md:p-8 hover:border-accent-200/70 transition-all duration-300"
            >
              <div className="w-12 h-12 rounded-xl bg-accent-50 flex items-center justify-center mb-5 group-hover:bg-accent-100 transition-colors duration-300">
                <i className={`${feature.icon} text-xl text-accent-600`}></i>
              </div>
              <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-3">
                {feature.title}
              </h3>
              <p className="text-foreground-600 text-sm leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}